/* eslint-disable import/order */
import { useCallback } from 'react';
import { LuxTheme, Typography } from '@lux/ds';
import { useLocation, useNavigate } from 'react-router-dom';
import { INavButtonItemProps, NavButtonItem } from './NavSubMenuItem.styles';
import { IProductModule } from '../../../configs/Products.types';

export interface INavSubMenuItemProps extends INavButtonItemProps, IProductModule {
  baseUrl?: string;
  closeMenu?: () => void;
  label: string;
  mainSelected?: boolean;
  path: string;
}

const NavSubMenuItem: React.FC<INavSubMenuItemProps> = ({
  baseUrl,
  closeMenu,
  label,
  mainSelected,
  margin,
  path,
  customRoutes,
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const active = mainSelected && pathname.includes(path);

  const handleNavigate = useCallback(() => {
    if (!active) {
      let baseUrlToUse = baseUrl;

      if (customRoutes) {
        if (window.IS_STAGING) {
          baseUrlToUse = customRoutes[1];
        } else if (window.IS_DEV) {
          baseUrlToUse = customRoutes[0];
        } else {
          baseUrlToUse = customRoutes[2];
        }
      }

      const spaUrl =
        (mainSelected || !baseUrlToUse) &&
        baseUrlToUse?.replace(/http[s]{0,1}:\/\//i, '') === window.location.hostname;

      const fullPath = spaUrl ? path : `${baseUrlToUse}${path}`;

      if (spaUrl) {
        navigate(fullPath);

        document.dispatchEvent(
          new CustomEvent('LUX_CORE_ROUTE_TRIGGER', { detail: { path: fullPath } }),
        );
      } else {
        window.location.replace(fullPath);
      }
    }

    closeMenu?.();
  }, [active, baseUrl, closeMenu, mainSelected, navigate, path]);

  return (
    <NavButtonItem margin={margin} onClick={handleNavigate}>
      <Typography
        color={active ? LuxTheme.palette.primary.shade[10] : LuxTheme.palette.primary.shade[40]}
        variant="bodyTextSmall"
        weight={active ? 'semibold' : 'regular'}
      >
        {label}
      </Typography>
    </NavButtonItem>
  );
};

export default NavSubMenuItem;
